import Select from 'react-select'
import TextField from 'Shared/components/TextField'
import validator from 'validator'
import FileUploader from 'Shared/components/ImageUploader/FileUploader'
import PillEditor from "Shared/components/PillEditor/PillEditor"
import AsyncSelect from 'Shared/components/AsyncSelect'
import axios from 'axios'
import applyCaseMiddleware from 'axios-case-converter'

const LinkFields = ({parameters, onChange}) => {
  const handleAttributeChange = (attr) => (value) => onChange({[attr]: value})
  const handleLinkTypeChange = ({value}) => onChange({linkType: value, flowId: null})
  const [mediaInfo, setMediaInfo] = useState(null)
  const client = applyCaseMiddleware(axios.create())

  const { mergeTags } = useSel(s => s.campaignBuilder)

  const onUploaded = ([ blobId ], filename) => {
    onChange({blobId, filename})
  }

  const handleMediaChange = (mediaId) => {
    if (mediaId) {
      handleAttributeChange('mediaId')(mediaId)
      client
        .get(`/api/media/${mediaId}`)
        .then((response) => {
          const { data } = response
          setMediaInfo(data)
        })
    }
  }

  useEffect(() => {
    if (parameters.mediaId) {
      handleMediaChange(parameters.mediaId)
    }
  }, [parameters.mediaId])

  const enablePages = window.ENV.FEATURES['flows'] || false
  const enableDashboards = window.ENV.FEATURES['dashboards'] || false
  const enableBallots = window.ENV.FEATURES['ballots'] || false

  const linkTypeOptions = [
    {value: 'web', label: 'Website'},
    {value: 'email', label: 'Email'},
    {value: 'phone', label: 'Phone number'},
    {value: 'file', label: 'File'},
    {value: 'media', label: 'Media'},
    enablePages && {value: 'flow', label: 'Page'},
    enableBallots && {value: 'ballot', label: 'Ballot'},
    enableDashboards && {value: 'dashboard', label: 'Dashboard'},
  ].filter(Boolean)

  const webLinkFields = () => (
    // <TextField label="Web address" defaultValue={block.parameters.url}
    // onValidChange={handleAttributeChange('url')}
    // validators={[{ fn: validator.isURL, msg: 'Invalid web address' }]} />
    <div className="field">
      <label>Web address</label>
      <PillEditor webLink singleLine condensed initialValue={parameters.url} onChange={handleAttributeChange('url')} availableTags={mergeTags} />
    </div>
  )

  const emailLinkFields = () => (
    <TextField id="email-address" label="Email address" defaultValue={parameters.email}
      onValidChange={handleAttributeChange('email')}
      validators={[{ fn: validator.isEmail, msg: 'Invalid email address' }]} />
  )

  const phoneLinkFields = () => (
    <TextField label="Phone number" defaultValue={parameters.phoneNumber} onValidChange={handleAttributeChange('phoneNumber')} />
  )

  const fileLinkFields = () => (
    <div className="field">
      <label>File</label>
      <FileUploader onUploaded={onUploaded} existingFilename={parameters.filename} />
    </div>
  )

  const pageLinkFields = () => (
    <div className="field">
      <label>Page</label>
      <AsyncSelect
        entity="flow"
        getOptionLabel={(v) => v.name || v.label}
        onChange={handleAttributeChange('flowId')}
        queryParameters={{
          section: 'pages'
        }}
        value={parameters.flowId}
        rootClassName=""
      />
    </div>
  )

  const ballotLinkFields = () => (
    <div className="field">
      <label>Ballot</label>
      <AsyncSelect
        entity="flow"
        getOptionLabel={(v) => v.name || v.label}
        onChange={handleAttributeChange('flowId')}
        queryParameters={{
          section: 'ballots'
        }}
        value={parameters.flowId}
        rootClassName=""
      />
    </div>
  )

  const dashboardLinkFields = () => (
    <div className="field">
      <label>Dashboard</label>
      <AsyncSelect
        entity="dashboard"
        getOptionLabel={(v) => v.name || v.label}
        onChange={handleAttributeChange('dashboardId')}
        value={parameters.dashboardId}
        rootClassName=""
      />
    </div>
  )

  const mediaLinkFields = () => (
    <div className="field">
      <label>Media</label>
      <AsyncSelect
        entity="media"
        entityApiRouteIsPlural={false}
        getOptionLabel={(v) => v.name || v.label}
        onChange={handleMediaChange}
        value={parameters.mediaId}
        rootClassName=""
      />
      {mediaInfo && mediaInfo.kind === 'image' && (
        <div className="media-preview margin-top">
          <img src={mediaInfo.url} alt={mediaInfo.name} />
        </div>
      )}
      {mediaInfo && mediaInfo.kind === 'video' && (
        <div className="media-preview margin-top">
          <video controls>
            <source src={mediaInfo.url} type={mediaInfo.mimeType} />
          </video>
        </div>
      )}
      {mediaInfo && mediaInfo.kind === 'document' && (
        <p className="filename">{mediaInfo.filename}</p>
      )}
    </div>
  )

  return (
    <>
      <div className="field">
        <label>Link to</label>
        <Select
          value={linkTypeOptions.find((o) => o.value === parameters.linkType)}
          options={linkTypeOptions}
          onChange={handleLinkTypeChange}
          classNamePrefix="link-type-select"
          styles={{
            menu: (provided) => ({
              ...provided,
              zIndex: 9999,
            }),
          }}
        />
      </div>
      {parameters.linkType === 'web' && webLinkFields()}
      {parameters.linkType === 'email' && emailLinkFields()}
      {parameters.linkType === 'phone' && phoneLinkFields()}
      {parameters.linkType === 'file' && fileLinkFields()}
      {(parameters.linkType === 'page' || parameters.linkType === 'flow') && pageLinkFields()}
      {parameters.linkType === 'ballot' && ballotLinkFields()}
      {parameters.linkType === 'media' && mediaLinkFields()}
      {parameters.linkType === 'dashboard' && dashboardLinkFields()}
    </>
  )
}

export default LinkFields
